<h5> Calibration Certificate Customer Name and Address </h5>


<div class="row">

  <div class="form-group col-md-6">
    <label for="exampleInputEmail1">Certificate Address</label>
    <select [(ngModel)]="Seletected_Certificate_Address" class="custom-select">
      <option value="">Address Registered in the Request</option>
      <option *ngFor="let item of DataList_Address" [value]="item">{{item}}</option>
    </select>
  </div>
  <div class="form-group col-md-6">
    <label for="exampleInputEmail1">Certificate Customer Name</label>
    <select [(ngModel)]="Seletected_Certificate_Name" class="custom-select">
      <option value="">Name Registered in the Request</option>
      <option *ngFor="let item of DataList_Name" [value]="item">{{item}}</option>
    </select>
  </div>
</div>

<button type="button" (click)="SubmitAddressLetter()" class="btn btn-success" style="margin-right: 5px;"><i class="fa fa-check"></i> Register Certificate Address </button>
